import React, { useState } from 'react'
import ReactPlayer from 'react-player/lazy'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

import './modal-video.scss'

const ModalVideo = ({ close }) => {
  const [played, setPLayed] = useState(0)

  const playAndPauseDataLayer = label => {
    pushEventDataLayer('Interacciones - Video', 'yogo-yogo', 'click', label)
  }

  const videoTimeDataLayer = seconds => {
    pushEventDataLayer(
      'Interacciones - Video',
      'yogo-yogo',
      'click',
      `${seconds}s`
    )
  }

  return (
    <div className="f-modalVideo-container">
      <div className="f-modalVideo-container__wrapper">
        <button
          className="f-modalVideo-container__wrapper__buttonClose"
          onClick={close}
        >
          X
        </button>
        <div className="f-modalVideo-container__wrapper__video">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=dT4c-a6jToE&ab_channel=Nosotras"
            controls={true}
            width="100%"
            height="100%"
            onEnded={() => playAndPauseDataLayer('Finalizo todo el video')}
            onPlay={() => playAndPauseDataLayer('Click play video')}
            onPause={() => videoTimeDataLayer(played)}
            onProgress={progress => setPLayed(progress.playedSeconds)}
          />
        </div>
      </div>
    </div>
  )
}

export default ModalVideo
